import React from "react";
import { useReducedHomeMotion } from "../../hooks/useReducedHomeMotion";
import "./homeAmbient.css";

/**
 * Orbes con gradientes radiales (sin filter:blur animado).
 * Solo transform en GPU — mucho más barato que blur(150px) en movimiento.
 */
export const AmbientGlow: React.FC = () => {
  const reduced = useReducedHomeMotion();

  return (
    <div className="home-ambient-layer pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden>
      <div
        className={`home-orb home-orb--lavender ${reduced ? "" : "home-orb--a"}`}
        style={{ width: "min(70vw, 520px)", height: "min(70vw, 520px)", left: 0, top: 0 }}
      />
      <div
        className={`home-orb home-orb--mint ${reduced ? "" : "home-orb--b"}`}
        style={{ width: "min(65vw, 480px)", height: "min(65vw, 480px)", left: 0, top: 0 }}
      />
      <div
        className={`home-orb home-orb--violet ${reduced ? "" : "home-orb--c"}`}
        style={{ width: "min(50vw, 380px)", height: "min(50vw, 380px)", left: 0, top: 0 }}
      />
    </div>
  );
};
